import { render, staticRenderFns } from "./DetachDialog.vue?vue&type=template&id=988ed274&"
import script from "./DetachDialog.vue?vue&type=script&lang=js&"
export * from "./DetachDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports